import { Suspense, lazy, useContext } from "react";
import { ChakraProvider, Button } from "@chakra-ui/react";
import { AppShell, ErrorShell } from "components/appshell";
import { AppContext } from "global";
import "./App.css";

const UploadContainer = lazy(() => import("components/upload/UploadContainer"));
const ProceedToStoreContainer = lazy(() =>
  import("components/store/ProceedToStoreContainer")
);
const StoreContainer = lazy(() => import("components/store/StoreContainer"));
const ProductContainer = lazy(() =>
  import("components/product/ProductContainer")
);

function App() {
  const {
    resetInventory,
    showUpload,
    showValidation,
    showProceedToStore,
    showStore,
    showProduct,
    activeProduct,
  } = useContext(AppContext);

  return (
    <ChakraProvider>
      <AppShell>
        {(showValidation || showStore || showProduct) && (
          <Button pos="absolute" top="0" right="0" onClick={resetInventory}>
            Upload Inventory
          </Button>
        )}
        <ErrorShell>
          {showUpload && (
            <Suspense fallback={<div>Loading...</div>}>
              <UploadContainer />
            </Suspense>
          )}
          {showProceedToStore && (
            <Suspense fallback={<div>Loading...</div>}>
              <ProceedToStoreContainer />
            </Suspense>
          )}
          {showStore && (
            <Suspense fallback={<div>Loading...</div>}>
              <StoreContainer />
            </Suspense>
          )}
          {showProduct && (
            <Suspense fallback={<div>Loading...</div>}>
              <ProductContainer product={activeProduct} />
            </Suspense>
          )}
        </ErrorShell>
      </AppShell>
    </ChakraProvider>
  );
}

export default App;
